import { withSwiperPage } from '@ad-lucy/components/builderComponents/VastVideo/withSwiperPage';
import { Arrows } from '@ad-lucy/components/nav/NavigationArrow/types';
import {
  CREATIVE_TYPE,
  type CreativesConfig,
  defaultCreativesConfig,
} from '@ad-lucy/config/creatives';
import { lazy } from 'react';
import type { componentNames } from './componentNames';

type CreativesConfigComponentKeys = (typeof componentNames)[number];

export const ceaConfig: CreativesConfig<CreativesConfigComponentKeys> = {
  ...defaultCreativesConfig,
  id: CREATIVE_TYPE.CEAXL,
  name: 'Content Engagement Ad XL 2.0',
  settings: {
    ...defaultCreativesConfig.settings,
    playIfNotInActiveTab: true,
    disableAutoplayOnInitialInteraction: true,
  },
  navigation: {
    ...defaultCreativesConfig.navigation,
    defaults: {
      ...defaultCreativesConfig.navigation.defaults,
      virtual: true,
    },
    arrows: Arrows.COLORED,
    swiperBreakpointOptions: {
      hpa: {
        slidesPerGroup: 1,
        slidesPerView: 1,
      },
      mobile: {
        slidesPerGroup: 1,
        slidesPerView: 1,
      },
    },
  },
  breakpoints: {
    ...defaultCreativesConfig.breakpoints,
    sitebar:
      'not (((min-height: 850px) and (max-width: 45vh)) or ((max-width: 449px) and (max-height: 849px)))',
    hpa: '(min-height: 850px) and (max-width: 45vh)',
    mobile: '(max-width: 449px) and (max-height: 849px)',
  },
  ambilight: defaultCreativesConfig.ambilight,
  components: {
    category: {
      ...defaultCreativesConfig.components.category,
      wrapper: lazy(
        () => import('@ad-lucy/ceaxl/components/styledBuilderComponents/StyledCategoryMenu'),
      ),
    },
    closeAd: {
      ...defaultCreativesConfig.components.closeAd,
      defaults: {
        ...defaultCreativesConfig.components.closeAd.defaults,
        centered: true,
      },
    },
    copyright: {
      ...defaultCreativesConfig.components.copyright,
    },
    countdown: {
      ...defaultCreativesConfig.components.countdown,
    },
    custom: {
      ...defaultCreativesConfig.components.custom,
    },
    footerLogo: {
      ...defaultCreativesConfig.components.footerLogo,
    },
    headerLogo: {
      ...defaultCreativesConfig.components.headerLogo,
    },
    html: {
      ...defaultCreativesConfig.components.html,
    },
    iframe: {
      ...defaultCreativesConfig.components.iframe,
    },
    image: {
      ...defaultCreativesConfig.components.image,
    },
    imageMap: {
      ...defaultCreativesConfig.components.imageMap,
    },
    imageMapArea: {
      ...defaultCreativesConfig.components.imageMapArea,
    },
    spotlights: {
      ...defaultCreativesConfig.components.spotlights,
    },
    spotlightsArea: {
      ...defaultCreativesConfig.components.spotlightsArea,
    },
    infoModal: {
      ...defaultCreativesConfig.components.infoModal,
    },
    link: {
      ...defaultCreativesConfig.components.link,
    },
    modal: {
      ...defaultCreativesConfig.components.modal,
      settings: {
        maxWidth: 'calc(100vh * (2 / 3) - 30px)',
      },
    },
    pricePatch: {
      ...defaultCreativesConfig.components.pricePatch,
    },
    expandableProductCard: {
      ...defaultCreativesConfig.components.expandableProductCard,
    },
    search: {
      ...defaultCreativesConfig.components.search,
    },
    slider: {
      ...defaultCreativesConfig.components.slider,
      defaultMetaData: {
        ...defaultCreativesConfig.components.slider.defaultMetaData,
        virtual: true,
      },
      settings: {
        autoplayOnlyInView: true,
      },
      wrapper: lazy(() => import('@ad-lucy/ceaxl/components/styledBuilderComponents/StyledSlider')),
    },
    sliderContainer: {
      ...defaultCreativesConfig.components.sliderContainer,
    },
    socialFlyoutBar: {
      ...defaultCreativesConfig.components.socialFlyoutBar,
      wrapper: lazy(
        () => import('@ad-lucy/ceaxl/components/styledBuilderComponents/StyledSocialFlyoutBar'),
      ),
    },
    socialMediaBar: {
      ...defaultCreativesConfig.components.socialMediaBar,
      wrapper: lazy(
        () => import('@ad-lucy/ceaxl/components/styledBuilderComponents/StyledSocialMediaBar'),
      ),
    },
    socialmedia: {
      ...defaultCreativesConfig.components.socialmedia,
      wrapper: lazy(
        () => import('@ad-lucy/ceaxl/components/styledBuilderComponents/StyledSocialMedia'),
      ),
    },
    socialmediaFooter: {
      ...defaultCreativesConfig.components.socialmediaFooter,
    },
    stickyCTA: {
      ...defaultCreativesConfig.components.stickyCTA,
    },
    stickyImage: {
      ...defaultCreativesConfig.components.stickyImage,
    },
    stickyText: {
      ...defaultCreativesConfig.components.stickyText,
      wrapper: lazy(
        () => import('@ad-lucy/ceaxl/components/styledBuilderComponents/StyleStickyText'),
      ),
    },
    store: {
      ...defaultCreativesConfig.components.store,
    },
    storeFinder: {
      ...defaultCreativesConfig.components.storeFinder,
    },
    storeMenu: {
      ...defaultCreativesConfig.components.storeMenu,
    },
    terms: {
      ...defaultCreativesConfig.components.terms,
    },
    text: {
      ...defaultCreativesConfig.components.text,
    },
    vastVideoXL: {
      ...defaultCreativesConfig.components.vastVideoXL,
      wrapper: withSwiperPage(
        lazy(() => import('@ad-lucy/components/builderComponents/VastVideo/VastVideoXL')),
      ),
    },
    viewLater: {
      ...defaultCreativesConfig.components.viewLater,
    },
    video: {
      ...defaultCreativesConfig.components.video,
    },
    hover: {
      ...defaultCreativesConfig.components.hover,
    },
    textButton: {
      ...defaultCreativesConfig.components.textButton,
    },
    imageComparator: {
      ...defaultCreativesConfig.components.imageComparator,
    },
    enhancedStore: {
      ...defaultCreativesConfig.components.enhancedStore,
    },
    sharingButtonFooter: {
      ...defaultCreativesConfig.components.sharingButtonFooter,
    },
  },
};
